module.exports = __webpack_public_path__ + "static/img/pic_toptitlle_daoshi@2x.7d443fcc.png";